import { useEffect } from 'react'

import { Button, Layout, Text } from '@loadsmart/loadsmart-ui'

import { useMobileOS } from 'core/ui/hooks/useMobileOS'

import { ReactComponent as LoadsmatLogo } from 'legacy/assets/svg/logos/loadsmart.svg'
import { analytics } from 'legacy/utils/analytics'

import { BannerWrapper, LogoWrapper } from './DownloadAppBanner.styles'

const downloadLinks = {
  AppStore:
    'https://apps.apple.com/us/app/loadsmart-loads/id1256783942?utm_campaign=Download%20App&utm_source=Spot%20quote%20-%20Single%20lane&utm_content=Top%20Banner',
  GooglePlay:
    'https://play.google.com/store/apps/details?id=com.loadsmart.liveloads&hl=en&gl=US&pli=1&utm_campaign=Download%20App&utm_source=Spot%20quote%20-%20Single%20lane&utm_content=Top%20Banner',
}

export function DownloadAppBanner() {
  const { isMobileOS, isAndroid, isIos } = useMobileOS()

  useEffect(() => {
    if (isMobileOS) {
      analytics.track('Download App Banner / View')
    }
  }, [isMobileOS])

  function handleDownload(utmMedium: string) {
    analytics.track('Download App Banner / Download', {
      ref: utmMedium,
    })

    if (isAndroid) {
      window.open(
        `${downloadLinks.GooglePlay}&utm_medium=${utmMedium}`,
        '_blank',
        'noopener noreferrer'
      )

      return
    }

    if (isIos) {
      window.open(
        `${downloadLinks.AppStore}&utm_medium=${utmMedium}`,
        '_blank',
        'noopener noreferrer'
      )
    }
  }

  if (!isMobileOS) return null

  return (
    <BannerWrapper>
      <LogoWrapper onClick={() => handleDownload('App icon')}>
        <LoadsmatLogo />
      </LogoWrapper>
      <Layout.Stack space="xs">
        <Text variant="body-bold">Download the Loads App!</Text>
        <Text>Receive real time notifications for new bid proposals and your rewarded bids</Text>
        <Button variant="primary" onClick={() => handleDownload('Download button')}>
          Download App
        </Button>
      </Layout.Stack>
    </BannerWrapper>
  )
}
